module.exports = __webpack_public_path__ + "img/wp.9c47e36a.png";